module.exports = __webpack_public_path__ + "img/Eezywork.9e8a8b5.png";